var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CACDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.132 31.727s1.433 10.032-.233 12.832c-2.767 3.5-7.366 4.533-13.899 7.7 3.266 7.599 6.766 13.065 10.332 16.631a38.41 38.41 0 0010.066 1.333c4.733 0 9.266-.866 13.432-2.433 3.367-3.7 6.4-8.866 8.933-15.132-10.133-5.766-10.666-5.366-13.2-8.099-1.399-1.5-1.899-5.3-2.132-13.432l-13.299.6z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.299 33.027l13.299 1.867c.266 5.6.833 8.432 2 9.666l.1.1c-9.2 2.9-11.864-1.914-15-5.1.034-2.4-.3-5.666-.4-6.533z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.797 22.029c-.433 0-.733.366-.966 1 1.133-19.932-21.532-18.565-20.732-.067-.233-.6-.533-.967-.966-.967-2.7-.233-.134 11.5 1.466 7.9 4.233 13.565 15.699 13.398 19.665-.3 1.133 4.633 4.57-7.6 1.533-7.566z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17 46.152s2.956 5.33 8.612 5.33c7.935 0 9.643-5.051 9.643-5.051l.278-.52s1.866.556 2.714.908c.848.35 8.794 2.483 10.248 6.48 0 0 .69 17.443-21.635 17.443C7.705 70.742 8.335 53.3 8.335 53.3c0-5.693 10.042-6.638 11.835-7.147z",
    fill: "#747779"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.58,
    r: 29,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.4980530782e29e4bdcf5d2acd1909a5e.svg";
export { ForwardRef as ReactComponent };